import { App } from 'vue';
import Table from './src/table.vue';

Table.install = (app: App): void => {
    app.component(Table.name, Table);
};

export default Table;

declare module 'vue' {
    export interface GlobalComponents {
        PtTable: typeof Table;
    }
}
